import { DefaultTheme } from 'styled-components'

import type { ThemeConfig } from './types.d'

export const createTheme = ({ colors }: ThemeConfig): DefaultTheme => {
  return {
    colors,
  }
}
